import api from './api';
const root = '/my-channels';
const path = (id) => `${root}/${encodeURIComponent(id)}`;
const data = (response) => response.data.data;
const myChannelsService = {
  posts: (id) => api.get(`${path(id)}/posts`).then(data),
  syncPosts: (id) => api.post(`${path(id)}/sync`, {}).then(data),
  preparePlan: (id, postId) => api.post(`${path(id)}/posts/${encodeURIComponent(postId)}/plan`, {}).then(data),
  regeneratePlan: (id, postId, planId) => api.post(`${path(id)}/posts/${encodeURIComponent(postId)}/plan/regenerate`, { plan_id: planId }).then(data),
  plan: (id, planId) => api.get(`${path(id)}/plans/${encodeURIComponent(planId)}`).then(data),
  startPlan: (id, planId) => api.post(`${path(id)}/plans/${encodeURIComponent(planId)}/start`, {}).then(data),
  cancelPlan: (id, planId) => api.post(`${path(id)}/plans/${encodeURIComponent(planId)}/cancel`, {}).then(data),
  updatePlan: (id, planId, body) => api.patch(`${path(id)}/plans/${encodeURIComponent(planId)}`, body).then(data),
  list: () => api.get(root).then(data),
  accounts: () => api.get(`${root}/accounts`).then(data),
  create: (body) => api.post(root, body).then(data),
  get: (id) => api.get(path(id)).then(data),
  update: (id, body) => api.patch(path(id), body).then(data),
  remove: (id) => api.delete(path(id)).then(data),
  join: (id, accountIds) => api.post(`${path(id)}/join`, { account_ids: accountIds }).then(data),
};
export default myChannelsService;
